import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import setting from '../views/setting.vue';
import manager from '../views/manager.vue';
import log from '../views/log.vue';
import records from '../views/records.vue';
import statics from '../views/statics.vue';
import create from '../views/create/create.vue';
import type from '../views/create/type.vue';
import rule from '../views/create/rule.vue';
import success from '../views/create/success.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'setting',
    component: setting,
  },
  {
    path: '/manager',
    name: 'manager',
    component: manager,
  },
  {
    path: '/log',
    name: 'log',
    component: log,
  },
  {
    path: '/records/:id',
    name: 'records',
    component: records,
  },
  {
    path: '/statics/:id',
    name: 'statics',
    component: statics,
  },
  {
    path: '/create',
    name: 'create',
    component: create,
    children: [
      {
        path: ':step',
        component: type
      },
      {
        path: ':step/:type',
        component: rule
      },
      {
        path: ':step/:type/:id',
        component: rule
      },
      {
        path: ':step/:type/:id/success',
        component: success
      }

    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
